<div class="main-container-finance">
  <div class="page-header">
    <div class="breadcrumb">
      <a (click)="backToDashboard()" class="crumb crumb-link">Finance Dashboard</a>
      <span class="crumb-sep">/</span>
      <a (click)="backToFinanceDetails()" class="crumb crumb-link">Finance Details</a>
      <span class="crumb-sep">/</span>
      <span class="crumb crumb-current">Project Details</span>
    </div>

    <div class="page-actions">
      <button
        *ngIf="isFinanceAdmin"
        mat-stroked-button
        class="add-projects-btn"
        type="button"
        (click)="openAddProjects()"
      >
        Add Projects
      </button>
    </div>
  </div>

  <mat-card class="content-card">
    <div class="section-header">
      <div class="section-title">
        <span>Project Details</span>
      </div>
      <div class="section-actions">
        <mat-form-field appearance="outline" class="search-field">
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            type="text"
            placeholder="Search"
            [(ngModel)]="searchText"
            (ngModelChange)="onSearchChange()"
          />
          <button
            *ngIf="searchText"
            matSuffix
            mat-icon-button
            aria-label="Clear search"
            (click)="clearSearch()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="inline-filter">
          <mat-label>Business Segment</mat-label>
          <mat-select
            [(value)]="selectedBusinessSegments"
            (selectionChange)="onBusinessSegmentsChange()"
            multiple
            placeholder="All"
          >
            <mat-select-trigger>
              {{ selectedBusinessSegments.length ? selectedBusinessSegments.length + ' selected' : 'All' }}
            </mat-select-trigger>
            <mat-option *ngFor="let s of businessSegmentOptions" [value]="s.code">{{ s.label }}</mat-option>
            <mat-option *ngIf="businessSegmentOptions.length === 0" disabled>No options available</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="inline-filter">
          <mat-label>Supporting LOB</mat-label>
          <mat-select
            [(value)]="selectedSupportingLobs"
            (selectionChange)="onSupportingLobsChange()"
            multiple
            placeholder="All"
          >
            <mat-select-trigger>
              {{ selectedSupportingLobs.length ? selectedSupportingLobs.length + ' selected' : 'All' }}
            </mat-select-trigger>
            <mat-option *ngFor="let lob of supportingLobOptions" [value]="lob.code">{{ lob.label }}</mat-option>
            <mat-option *ngIf="supportingLobOptions.length === 0" disabled>No options available</mat-option>
          </mat-select>
        </mat-form-field>

        <button
          mat-stroked-button
          class="download-btn"
          type="button"
          (click)="comingSoon('Download')"
        >
          <mat-icon>file_download</mat-icon>
          <span>Download</span>
        </button>
      </div>
    </div>

    <ng-container *ngIf="loading">
      <ngx-skeleton-loader count="8" [theme]="{ height: '44px', 'margin-bottom': '4px' }"></ngx-skeleton-loader>
    </ng-container>

    <div *ngIf="errorMessage && !loading" class="error-state">{{ errorMessage }}</div>

    <ng-container *ngIf="!loading && !errorMessage">
      <div class="table-wrap">
        <table mat-table [dataSource]="rows" [trackBy]="trackByProjectId" class="project-details-table">
          <ng-container matColumnDef="edit" sticky>
            <th mat-header-cell *matHeaderCellDef>Edit</th>
            <td mat-cell *matCellDef="let row">
              <button
                type="button"
                mat-icon-button
                class="row-action"
                aria-label="Edit project"
                [matTooltip]="isFinanceAdmin ? 'Edit project' : 'Finance admin only'"
                [disabled]="!isFinanceAdmin"
                (click)="openEditProject(row)"
              >
                <mat-icon>edit</mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row">
              <span class="status-pill" [class.inactive]="isInactive(row.status)">
                <mat-icon class="status-icon">
                  {{ isInactive(row.status) ? 'work_off' : 'work' }}
                </mat-icon>
                <span>{{ row.status || '—' }}</span>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="businessSegment">
            <th mat-header-cell *matHeaderCellDef>Business Segment</th>
            <td mat-cell *matCellDef="let row">{{ row.businessSegment || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="supportingLob">
            <th mat-header-cell *matHeaderCellDef>Supporting LOB</th>
            <td mat-cell *matCellDef="let row">{{ row.supportingLob || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="productSuite">
            <th mat-header-cell *matHeaderCellDef>Product Suite</th>
            <td mat-cell *matCellDef="let row">{{ row.productSuite || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="agileTeam">
            <th mat-header-cell *matHeaderCellDef>Agile Team</th>
            <td mat-cell *matCellDef="let row">{{ row.agileTeam || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="projectName">
            <th mat-header-cell *matHeaderCellDef>Project Name</th>
            <td mat-cell *matCellDef="let row">{{ row.projectName || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="projectIdCode">
            <th mat-header-cell *matHeaderCellDef>Project ID</th>
            <td mat-cell *matCellDef="let row">{{ row.projectIdCode || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="svp">
            <th mat-header-cell *matHeaderCellDef>SVP</th>
            <td mat-cell *matCellDef="let row">{{ row.svp || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="vp">
            <th mat-header-cell *matHeaderCellDef>VP</th>
            <td mat-cell *matCellDef="let row">{{ row.vp || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="functionalManager">
            <th mat-header-cell *matHeaderCellDef>Functional Manager</th>
            <td mat-cell *matCellDef="let row">{{ row.functionalManager || '—' }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

          <tr class="empty-row" *matNoDataRow>
            <td [attr.colspan]="displayedColumns.length">
              No projects match the current filters.
            </td>
          </tr>
        </table>
      </div>

      <mat-paginator
        class="project-details-paginator"
        [length]="totalElements"
        [pageSize]="size"
        [pageIndex]="page"
        [pageSizeOptions]="pageSizeOptions"
        [showFirstLastButtons]="true"
        aria-label="Project Details pagination"
        (page)="onPageEvent($event)"
      ></mat-paginator>
    </ng-container>
  </mat-card>
</div>
